import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDAvatar from "components/MDAvatar";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

import {
  supplierUpdating,
  createSupplier,
  getSupplierList,
} from "actions/supplierActions";
import { getProfile } from "actions/userActions";

import MDActionConfigurator from "components/MDActionConfigurator";
// import MDSupplierCard from "components/MDSupplierCard";

function Suppliers() {
  const configuratorRef = useRef(null);
  const dispatch = useDispatch();
  const [currentState, setCurrentState] = useState("");
  const [currentData, setCurrentData] = useState({
    _id: "",
    supplierName: "",
    supplierLogo: "",
    supplierEmail: "",
    supplierPhone: "",
    supplierRelationshipManagerPhone: "",
    supplierRelationshipManagerEmail: "",
    supplierUnderWriterPhone: "",
    supplierUnderWriterEmail: "",
    supplierAddress: "",
    active: true,
    created_at: "",
  });

  const getMe = useSelector((state) => state.getMe);
  const { me } = getMe;

  useEffect(() => {
    // if (me?.length === 0) {
    dispatch(getProfile());
    // }
  }, [dispatch]);

  const listSuppliers = useSelector((state) => state.listSuppliers);
  const { suppliersList } = listSuppliers;

  useEffect(() => {
    if (suppliersList?.length === 0) {
      dispatch(getSupplierList());
    }
  }, [dispatch, suppliersList?.length]);

  const handleToggleBackdrop = (item, state) => {
    setCurrentData(item);
    setCurrentState(state);
    if (configuratorRef.current) {
      configuratorRef.current.handleToggleConfigurator();
    }
  };

  const handleSubmitSupplier = (e) => {
    if (currentState === "edit") {
      dispatch(supplierUpdating(currentData?._id, e));
    } else {
      dispatch(createSupplier(e));
    }
    handleToggleBackdrop({}, "");
  };

  const Supplier = ({ image, name, email }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDAvatar src={image} name={name} size="sm" />
      <MDBox ml={2} lineHeight={1}>
        <MDTypography
          display="block"
          variant="button"
          fontWeight="medium"
          sx={{
            color: ({ palette: { text } }) => text.darkAccent,
          }}
        >
          {name}
        </MDTypography>
        {/* <MDTypography variant="caption">{email}</MDTypography> */}
      </MDBox>
    </MDBox>
  );

  const Job = ({ title, description }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography
        display="block"
        variant="caption"
        sx={{
          color: ({ palette: { text } }) => text.darkAccent,
        }}
        fontWeight="medium"
      >
        {title}
      </MDTypography>
      {/* <MDTypography variant="caption">{description}</MDTypography> */}
    </MDBox>
  );

  function renderRows(data) {
    const values = [];
    data?.forEach((item, index) => {
      const newElement = {
        suppliers: (
          <Link to={`/suppliers/${item?._id}`}>
            <Supplier
              key={index}
              image={item.supplierLogo}
              name={item.supplierName}
              // email={item.email}
            />
          </Link>
        ),
        email: <Job title={item.supplierEmail} description="Email" />,
        phone: <Job title={item.supplierPhone} description="Mobile" />,
        joined: (
          <MDTypography
            variant="caption"
            sx={{
              color: ({ palette: { text } }) => text.darkAccent,
            }}
            fontWeight="medium"
          >
            {moment(item.created_at).format("Do MMMM YYYY")}
          </MDTypography>
        ),
        products: (
          <MDTypography
            component="a"
            href="#"
            variant="caption"
            sx={{
              color: ({ palette: { text } }) => text.darkAccent,
            }}
            fontWeight="medium"
          >
            {item.products.length}
          </MDTypography>
        ),
        orders: (
          <MDTypography
            component="a"
            href="#"
            variant="caption"
            sx={{
              color: ({ palette: { text } }) => text.darkAccent,
            }}
            fontWeight="medium"
          >
            {item.orders.length}
          </MDTypography>
        ),
      };
      values.push(newElement);
    });
    return values;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox>
              {(me?.role === "super_admin" || me?.role === "admin") && (
                <MDBox p={2} mt="auto" display="flex" justifyContent="end">
                  <MDButton
                    component="a"
                    href="#"
                    rel="noreferrer"
                    variant="gradient"
                    color="light"
                    onClick={() =>
                      handleToggleBackdrop(
                        {
                          supplierName: "",
                          supplierLogo: "",
                          supplierEmail: "",
                          supplierPhone: "",
                          supplierRelationshipManagerPhone: "",
                          supplierRelationshipManagerEmail: "",
                          supplierUnderWriterPhone: "",
                          supplierUnderWriterEmail: "",
                          supplierAddress: "",
                          active: true,
                          created_at: "",
                        },
                        ""
                      )
                    }
                  >
                    <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                    &nbsp;New Supplier
                  </MDButton>
                </MDBox>
              )}

              <DataTable
                table={{
                  columns: [
                    {
                      Header: "suppliers",
                      accessor: "suppliers",
                      width: "20%",
                      align: "left",
                    },
                    {
                      Header: "email",
                      accessor: "email",
                      width: "20%",
                      align: "left",
                    },
                    {
                      Header: "phone",
                      accessor: "phone",
                      width: "20%",
                      align: "left",
                    },
                    {
                      Header: "joined",
                      accessor: "joined",
                      width: "10%",
                      align: "center",
                    },
                    {
                      Header: "products",
                      accessor: "products",
                      width: "10%",
                      align: "center",
                    },
                    {
                      Header: "orders",
                      accessor: "orders",
                      width: "10%",
                      align: "center",
                    },
                  ],

                  rows: renderRows(suppliersList),
                }}
                isSorted={false}
                entriesPerPage={false}
                showTotalEntries={true}
                noEndBorder
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>

      <MDActionConfigurator
        ref={configuratorRef}
        title="Supplier Config"
        onCompleteConfig={handleSubmitSupplier}
        data={[
          {
            keyType: "_id",
            valueType: currentData?._id,
          },
          {
            labelType: "Supplier Name",
            placeholderType: "Enter Supplier Name",
            dataType: "text",
            keyType: "supplierName",
            valueType: currentData?.supplierName,
          },
          {
            labelType: "Supplier Email",
            placeholderType: "Enter Supplier Email",
            dataType: "email",
            keyType: "supplierEmail",
            valueType: currentData?.supplierEmail,
          },
          {
            labelType: "Supplier Phone",
            placeholderType: "Enter Supplier Phone",
            dataType: "phone",
            keyType: "supplierPhone",
            valueType: currentData?.supplierPhone,
          },
          {
            labelType: "Supplier Relationship Manager Phone",
            placeholderType: "Enter Supplier Relationship Manager Phone",
            dataType: "phone",
            keyType: "supplierRelationshipManagerPhone",
            valueType: currentData?.supplierRelationshipManagerPhone,
          },
          {
            labelType: "Supplier Relationship Manager Email",
            placeholderType: "Enter Supplier Relationship Manager Email",
            dataType: "email",
            keyType: "supplierRelationshipManagerEmail",
            valueType: currentData?.supplierRelationshipManagerEmail,
          },
          {
            labelType: "Supplier UnderWriter Phone",
            placeholderType: "Enter Supplier UnderWriter Phone",
            dataType: "phone",
            keyType: "supplierUnderWriterPhone",
            valueType: currentData?.supplierUnderWriterPhone,
          },
          {
            labelType: "Supplier UnderWriter Email",
            placeholderType: "Enter Supplier UnderWriter Email",
            dataType: "email",
            keyType: "supplierUnderWriterEmail",
            valueType: currentData?.supplierUnderWriterEmail,
          },
          {
            labelType: "Supplier Address",
            placeholderType: "Enter Supplier Address",
            dataType: "text",
            keyType: "supplierAddress",
            valueType: currentData?.supplierAddress,
          },
          {
            labelType: "Supplier Logo",
            placeholderType: "Enter Supplier Logo",
            dataType: "image",
            keyType: "supplierLogo",
            valueType: currentData?.supplierLogo,
          },
          // {
          //   labelType: "Active",
          //   placeholderType: "Active",
          //   dataType: "active",
          //   keyType: "active",
          //   valueType: currentData?.active,
          // },
        ]}
        state={currentState}
      />

      <Footer />
    </DashboardLayout>
  );
}

export default Suppliers;
